{
  "#MDE_ETIKETTENDRUCK": { }
}
